"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const createSvgIcon_1 = __importDefault(require("../utils/createSvgIcon"));
exports.default = (0, createSvgIcon_1.default)(react_1.default.createElement("g", null,
    react_1.default.createElement("path", { fillRule: "evenodd", d: "M17.5986 14.4676 13.4859 12l4.1127-2.4676v4.9352Zm1.2428-8.0133L11.5986 10.8V6.9342a.5.5 0 0 0-.7773-.416L3.2227 11.584a.5.5 0 0 0 0 .832l7.5986 5.0658a.5002.5002 0 0 0 .7773-.4161V13.2l7.2428 4.3456a.5.5 0 0 0 .7572-.4287V6.8831a.5.5 0 0 0-.7572-.4288ZM6.2042 12l3.3944 2.263V9.737L6.2042 12Z", clipRule: "evenodd" })), 'BackwardsIcon');
